module.exports = __webpack_public_path__ + "static/media/male-musculature.7741143a.png";